module.exports = __webpack_public_path__ + "img/hg.5bb7d7da.png";